/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Uploadfailedtitle2Inputs */

const en_common_uploadfailedtitle2 = /** @type {(inputs: Common_Uploadfailedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Failed`)
};

/**
* | output |
* | --- |
* | "Upload Failed" |
*
* @param {Common_Uploadfailedtitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_uploadfailedtitle2 = /** @type {((inputs?: Common_Uploadfailedtitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Uploadfailedtitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_uploadfailedtitle2(inputs)
});
export { common_uploadfailedtitle2 as "common_uploadFailedTitle" }